
import { AlbumModel } from '@/models'
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'

@Component
export default class AlbumsSearch extends Vue {
    @Prop()
    albums !: AlbumModel[]
    @Prop({default: false})
    more !: boolean
}
